import { render, staticRenderFns } from "./OrganizationSearch.vue?vue&type=template&id=61d10524"
import script from "./OrganizationSearch.vue?vue&type=script&lang=js"
export * from "./OrganizationSearch.vue?vue&type=script&lang=js"
import style0 from "./OrganizationSearch.vue?vue&type=style&index=0&id=61d10524&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports